import { render } from "./MfMiniSiteApp.vue?vue&type=template&id=2a49c9ce&scoped=true&ts=true"
import script from "./MfMiniSiteApp.vue?vue&type=script&lang=ts"
export * from "./MfMiniSiteApp.vue?vue&type=script&lang=ts"

import "./MfMiniSiteApp.vue?vue&type=style&index=0&id=2a49c9ce&scoped=true&lang=postcss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a49c9ce"]])

export default __exports__